import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './Bullets.module.scss';

const Bullets = ({ tag, data, children, star, empty, dot, checkmark, checkmarkViolet, checkmarkWhite, hardware, variantInvert, compact, ...extra }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      {...extra}
      data-bem="Bullets"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN.variantInvert]: variantInvert, // white on colored background with purple check
        [CN.star]: star,
        [CN.empty]: empty,
        [CN.dot]: dot,
        [CN.checkmark]: checkmark,
        [CN.checkmarkViolet]: checkmarkViolet,
        [CN.checkmarkWhite]: checkmarkWhite,
        [CN.hardware]: hardware,
        [CN.compact]: compact, // no padding between items
        [CN.dark]: isDarkMode,
      })}
    >
      {data.map((text, index) => (
        <div className={CN.list} key={createNodeKey({ index, text })}>
          {text}
        </div>
      ))}
      {children}
    </div>
  );
};
export default Bullets;
